module.exports = __webpack_public_path__ + "assets/img/HeaderSquare.667ab951.png";